import React from 'react';

const POHeader = ({ supplier = {} }) => {
  return (
    <div className="po-company-section">
      <div className="po-logo">
        <img src="/logo.png" alt="Vidyutcloud Logo" />
      </div>

      <div className="po-company-details">
        <h2>{supplier?.name}</h2>
        <p>{supplier?.address}</p>
        <p>GSTIN: {supplier?.gstin}</p>
        <p>PAN: {supplier?.pan}</p>
        <p>Contact: {supplier?.contact}</p>
        <p>Email: {supplier?.email}</p>
      </div>
    </div>
  );
};

export default POHeader;